import React, { Component } from "react";
import Carousel from "@itseasy21/react-elastic-carousel";

import arrowImg from "../images/RelatedArrow.png";

import products from "./items/ItemsRelatedResult"

class RelatedResult extends Component {
  constructor(props) {
    super(props);
    this.breakPoints = [
      { width: 375, itemsToShow: 1, itemsToScroll: 1, pagination: false },
      { width: 600, itemsToShow: 2, itemsToScroll: 1 },
      { width: 992, itemsToShow: 4, itemsToScroll: 1 },
    ];
  }
  render() {
    return (
      <div>
        <Carousel breakPoints={this.breakPoints}>
          {products.map((products) => {
            return (
              <a
                rel="noopener noreferrer"
                className="List-related-result text-white rounded mb-5 d-flex flex-row align-items-center w-75 px-2"
                key={products}
                style={{ textDecoration: 'none' }}
                draggable="false" // Disable dragging
              >
                <div className="List-image-container">
                  <img src={products.image} alt="image" className="rounded img-fluid mx-auto d-block"/>
                </div>
                <div className="List-related-result-body d-flex text-start flex-column align-items-start px-3">
                  <h3>{products.Email}</h3>
                  <h3>{products.Price}</h3>
                  <img src={arrowImg} alt="Arrow" className="rounded-circle img-fluid mx-auto d-block" />
                </div>
              </a>
            );
          })}
        </Carousel>
      </div>
    );
  }
}
export default RelatedResult;
